module.exports = __webpack_public_path__ + "img/40_41.13c02a67.png";